<section *ngIf="visible" class="p-grid">
  <div class="p-col-12 p-jc-center p-col-row p-grid">
    <div class="p-col-6">
      <h2>Add Sensor Failure</h2>
    </div>
  </div>
</section>
<section *ngIf="visible" class="p-col-12">
  <form [formGroup]="editForm" (ngSubmit)="confirm()">
    <div class="p-col-12 p-grid p-jc-center p-col-row p-fluid p-formgrid">
      <div class="p-col-6 p-grid">
        <div class="p-col-6 p-col-row no-float">
          <label for="pod_serial_number">Pod Serial Number</label>
          <input ngDefaultControl formControlName="pod_serial_number" type="text"
            [(ngModel)]="sensorFailure.pod_serial_number" pInputText maxlength="25" />
        </div>
        <div class="p-col-6 p-col-row no-float">
          <label for="sensor_serial_number">Sensor Serial Number</label>
          <input ngDefaultControl formControlName="sensor_serial_number" type="text"
            [(ngModel)]="sensorFailure.sensor_serial_number" pInputText maxlength="9" />
        </div>
        <div class="p-col-6 p-col-row no-float">
          <label for="replacement_sensor_serial">Replacement Sensor Serial</label>
          <input ngDefaultControl formControlName="replacement_sensor_serial" type="text"
            [(ngModel)]="sensorFailure.replacement_sensor_serial" pInputText />
        </div>
        <div class="p-col-6 p-col-row no-float">
          <label for="fail_date">Fail Date</label> <br />
          <p-datepicker ngDefaultControl formControlName="failure_date" [(ngModel)]="sensorFailure.failure_date"
            dateFormat="dd-M-yy" [showTime]="true" [style]="{'width': '100%'}"></p-datepicker>
        </div>
        <div class="p-col-12 p-col-row no-float">
          <label for="notes" novalidate>Notes</label> <br />
          <p-autoComplete ngDefaultControl formControlName="notes" [(ngModel)]="noteSelected" [suggestions]="typeAheadFiltered"
            (completeMethod)="autoComplete($event)" [size]="100" field="notes">{{typeAheadFiltered}}</p-autoComplete>
        </div>
        <div class="p-col-12 p-grid p-jc-end">
          <div class="p-col-2">
            <button label="Confirmed Failure" type="button" icon="far fa-thumbs-down"
              class="p-button-raised  p-button-success" pButton (click)="confirm()" positionStyle="fixed"
              pTooltip="Confirm failure and optionally ship replacement sensor nominated"
              [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted">
            </button>
          </div>
          <div class="p-col-2">
            <button label="Reported" type="button" icon="fa fa-file" class="p-button-raised  p-button-primary" pButton
              (click)="reported()" positionStyle="fixed" pTooltip="Reported sensor failure."
              [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted">
            </button>
          </div>
          <div class="p-col-2">
            <button label="Close" type="button" icon="far fa-window-close" class="p-button-raised  p-button-warning"
              pButton (click)="exit()" positionStyle="fixed" pTooltip="Return to the list of failures"
              [disabled]="submitted">
            </button>
          </div>
        </div>
      </div>

    </div>
  </form><br /><br /> <br /> <br /> <br /> <br /> <br />
</section>
